import { styled } from "styled-components";
import { mobile } from "../utilities/responsive";

const Button = styled.button`
  position: absolute;
  display: block;
  top: 10px;
  right: 10px;
  color: white;
  border: none;
  background-color: transparent;
  cursor: pointer;
  font-size: 2vw;
  font-family: "Amatic SC", cursive;
  font-weight: 700;

  ${mobile({ fontSize: "6vw"})}
`;

const SkipButton = ({ text, setAnimate }) => {
  return (
    <>
      <Button onClick={(() => setAnimate(false))}>{text}</Button>
    </>
  );
};

export default SkipButton;
